export default __webpack_public_path__ + "static/media/3.09c659ad.webp";